"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSideCart = void 0;
const react_1 = require("react");
const useFeatureFlag_1 = require("../../hooks/useFeatureFlag");
const SIDE_CART_FLAG_KEY = 'showSideCart';
const SIMILAR_PRODUCTS_KEY = 'similarProducts';
/**
 * Hook que verifica se o carrinho lateral deve ser exibido
 * Monitora mudanças no localStorage para a chave de similarProducts
 * @returns {boolean} - true se o carrinho lateral deve ser exibido
 */
const useSideCart = () => {
    const [hasSideCart, loading] = (0, useFeatureFlag_1.useFeatureFlag)(SIDE_CART_FLAG_KEY, true);
    const [hasSideCartEnabled, setHasSideCartEnabled] = (0, react_1.useState)(false);
    const currentStorageValue = (0, react_1.useRef)(null);
    const checkSideCartEnabled = (0, react_1.useCallback)(() => {
        try {
            const similarProductsOnStorage = localStorage.getItem(SIMILAR_PRODUCTS_KEY);
            currentStorageValue.current = similarProductsOnStorage;
            const parsedSimilarProducts = JSON.parse(similarProductsOnStorage || '{}');
            const hasSimilarProducts = Boolean(similarProductsOnStorage) && Object.keys(parsedSimilarProducts).length > 0;
            if (hasSimilarProducts) {
                return false;
            }
            return Boolean(hasSideCart) && !loading;
        }
        catch (error) {
            return false;
        }
    }, [hasSideCart, loading]);
    const handleStorageChange = (0, react_1.useCallback)((event) => {
        if (!event || event.key === SIMILAR_PRODUCTS_KEY) {
            const newValue = checkSideCartEnabled();
            setHasSideCartEnabled(newValue);
        }
    }, [checkSideCartEnabled]);
    (0, react_1.useEffect)(() => {
        handleStorageChange();
        window.addEventListener('storage', handleStorageChange);
        const checkOnUserInteraction = () => {
            const latestValue = localStorage.getItem(SIMILAR_PRODUCTS_KEY);
            if (latestValue !== currentStorageValue.current) {
                handleStorageChange();
            }
        };
        document.addEventListener('click', checkOnUserInteraction);
        document.addEventListener('keyup', checkOnUserInteraction);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            document.removeEventListener('click', checkOnUserInteraction);
            document.removeEventListener('keyup', checkOnUserInteraction);
        };
    }, [handleStorageChange]);
    return hasSideCartEnabled;
};
exports.useSideCart = useSideCart;
